import { render, staticRenderFns } from "./navbar-close.vue?vue&type=template&id=894868b8"
import script from "./navbar-close.vue?vue&type=script&lang=js"
export * from "./navbar-close.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports